// API服务配置
// 使用相对路径，利用开发服务器的代理功能
const API_BASE_URL = '/api';

// 基础请求方法
async function request(url, options = {}) {
  try {
    
    const response = await fetch(`${API_BASE_URL}${url}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      }
    });
    
    
    

    // 检查响应状态码
    if (!response.ok) {
      // 如果响应状态码不是200-299，尝试解析响应内容
      let errorMessage = '请求失败';
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;
      } catch (e) {
        // 如果无法解析为JSON，使用状态文本
        errorMessage = response.statusText || errorMessage;
      }
      return {
        success: false,
        message: errorMessage
      };
    }

    // 解析响应数据
    let data;
    try {
      // 检查响应是否为空
      const text = await response.text();
      if (text.trim() === '') {
        // 空响应，返回默认成功对象
        return {
          success: true,
          data: null
        };
      }
      data = JSON.parse(text);
      
    } catch (error) {
      
      return {
        success: false,
        message: `请求成功，但无法解析响应数据: ${error.message}`
      };
    }

    return data;
  } catch (error) {
    
    return {
      success: false,
      message: `网络请求失败: ${error.message}`
    };
  }
}

// 认证相关API
export const authAPI = {
  // 登录
  login(data) {
    return request('/auth/login', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  },
  
  // 注册
  register(data) {
    return request('/auth/register', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  },
  
  // 获取当前用户信息
  getCurrentUser() {
    const token = localStorage.getItem('token');
    return request('/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};

// 新闻相关API - 统一的新闻接口，用于动态咨询和新闻资讯页面
export const newsAPI = {
  // 获取最新新闻 - 用于首页动态咨询展示
  getLatestNews(limit = 3) {
    return request(`/news/latest?limit=${limit}`);
  },
  
  // 获取新闻列表 - 用于新闻资讯页面
  getNewsList(page = 1, limit = 10, status = 'published', search = '') {
    const token = localStorage.getItem('token');
    let url = `/news?page=${page}&limit=${limit}`;
    if (status) url += `&status=${status}`;
    if (search) url += `&search=${search}`;
    
    const options = {};
    if (token) {
      options.headers = {
        Authorization: `Bearer ${token}`
      };
    }
    
    return request(url, options);
  },
  
  // 获取新闻详情 - 通用的新闻详情接口
  getNewsDetail(id) {
    return request(`/news/${id}`);
  },
  
  // 创建新闻
  createNews(data) {
    const token = localStorage.getItem('token');
    return request('/news', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 更新新闻
  updateNews(id, data) {
    const token = localStorage.getItem('token');
    return request(`/news/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 删除新闻
  deleteNews(id) {
    const token = localStorage.getItem('token');
    return request(`/news/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 更新新闻状态（审核功能）
  updateNewsStatus(id, status) {
    const token = localStorage.getItem('token');
    return request(`/news/${id}/status`, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ status })
    });
  }
};

// 用户管理API
export const userAPI = {
  // 获取用户列表
  getUserList(page = 1, limit = 10, search = '') {
    const token = localStorage.getItem('token');
    let url = `/users?page=${page}&limit=${limit}`;
    if (search) url += `&search=${search}`;
    return request(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 获取用户详情
  getUserDetail(id) {
    const token = localStorage.getItem('token');
    return request(`/users/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 创建用户
  createUser(data) {
    const token = localStorage.getItem('token');
    return request('/users', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
  },
  
  // 更新用户
  updateUser(id, data) {
    const token = localStorage.getItem('token');
    return request(`/users/${id}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
  },
  
  // 删除用户
  deleteUser(id) {
    const token = localStorage.getItem('token');
    return request(`/users/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};

// 媒体库API
export const mediaAPI = {
  // 上传媒体文件
  uploadMedia(file) {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('file', file);
    
    return fetch(`${API_BASE_URL}/media/upload`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        // 如果响应状态码不是200-299，创建一个错误对象
        return Promise.reject(new Error('请求失败'));
      }
      return response.json();
    })
    .catch(() => ({
      success: false,
      message: '请求失败'
    }));
  },
  
  // 获取媒体列表
  getMediaList(page = 1, pageSize = 10, search = '') {
    const token = localStorage.getItem('token');
    let url = `/media?page=${page}&pageSize=${pageSize}`;
    if (search) url += `&search=${search}`;
    return request(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 获取媒体详情
  getMedia(id) {
    const token = localStorage.getItem('token');
    return request(`/media/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 更新媒体信息
  updateMedia(id, data) {
    const token = localStorage.getItem('token');
    return request(`/media/${id}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
  },
  
  // 删除媒体
  deleteMedia(id) {
    const token = localStorage.getItem('token');
    return request(`/media/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 批量删除媒体
  batchDeleteMedia(ids) {
    const token = localStorage.getItem('token');
    return request('/media/batch', {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ ids })
    });
  }
};

// 角色管理API
export const roleAPI = {
  // 获取所有角色
  getAllRoles() {
    const token = localStorage.getItem('token');
    return request('/roles', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 获取用户角色
  getUserRoles(userId) {
    const token = localStorage.getItem('token');
    return request(`/roles/user/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 更新用户角色
  updateUserRoles(userId, roleIds) {
    const token = localStorage.getItem('token');
    return request(`/roles/user/${userId}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ roleIds })
    });
  }
};

// 轮播图相关API
export const bannerAPI = {
  // 获取轮播图列表
  getBannerList(page = 1, limit = 10, status = '', search = '') {
    const token = localStorage.getItem('token');
    let url = `/banners?page=${page}&limit=${limit}`;
    if (status) url += `&status=${status}`;
    if (search) url += `&search=${search}`;
    return request(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 获取激活的轮播图列表（用于前端展示）
  getActiveBanners() {
    return request('/banners/active');
  },
  
  // 获取轮播图详情
  getBannerDetail(id) {
    const token = localStorage.getItem('token');
    return request(`/banners/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  // 创建轮播图
  createBanner(data) {
    const token = localStorage.getItem('token');
    return request('/banners', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
  },
  
  // 更新轮播图
  updateBanner(id, data) {
    const token = localStorage.getItem('token');
    return request(`/banners/${id}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
  },
  
  // 删除轮播图
  deleteBanner(id) {
    const token = localStorage.getItem('token');
    return request(`/banners/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
